import { render, staticRenderFns } from "./AttendeeList.vue?vue&type=template&id=6ffacd1b&"
import script from "./AttendeeList.vue?vue&type=script&lang=js&"
export * from "./AttendeeList.vue?vue&type=script&lang=js&"
import style0 from "./AttendeeList.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports